import React, { useEffect } from 'react';
import { gapi } from 'gapi-script';

const SyncWithCloud = () => {

  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        apiKey: process.env.API_KEY,
        clientId: process.env.CLIENT_ID,
        scope: process.env.SCOPES,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
      });
    };

    gapi.load('client:auth2', initClient);
  }, []);

  const uploadFile = () => {
    const fileContent = 'Hello World!'; // Example file content
    const file = new Blob([fileContent], { type: 'text/plain' });
    const metadata = {
      name: 'sample.txt', // File name at Google Drive
      mimeType: 'text/plain', // MIME type
    };
    let accessToken
    if (accessToken) {

      accessToken = gapi.auth.getToken().access_token; // Ensure user is authenticated
    } else {
      console.log('user is not authenticated')
    }

    fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
      method: 'POST',
      headers: new Headers({
        'Authorization': 'Bearer ' + accessToken
      }),
      body: createMultipartBody(file, metadata),
    }).then((res) => {
      if (res.ok) {
        console.log('File uploaded successfully');
      }
    });
  };

  const createMultipartBody = (file, metadata) => {
    const boundary = '-------314159265358979323846';
    const delimiter = "\r\n--" + boundary + "\r\n";
    const closeDelimiter = "\r\n--" + boundary + "--";

    const base64Data = btoa(file);
    const multipartRequestBody =
      delimiter +
      'Content-Type: application/json\r\n\r\n' +
      JSON.stringify(metadata) +
      delimiter +
      'Content-Type: ' + file.type + '\r\n' +
      'Content-Transfer-Encoding: base64\r\n' +
      '\r\n' +
      base64Data +
      closeDelimiter;

    return multipartRequestBody;
  };

  return (
    <div className='vr-set-page'>
      <h2 className="vr-set-title">
        Sync With Cloud
      </h2>
      <div className='vr-set-card'>
        <div className='vr-set-options'>
          <div className='vr-set-option'
            role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
            onClick={(e) => uploadFile(e)}
          >
            <div className="form-check">
              <div className="vr-set-option-img">
                <img src="../img/accountsetting/google-drive.png" />
              </div>
              <div className="form-check-label">
                <span className="vr-set-option-title">
                  Connect To Google Drive
                  <p className="vr-set-option-desc">
                    Link Your account to Google Drive for cloud storage integration
                  </p>
                </span>
              </div>
              <div>
                <img src="../img/accountsetting/Frame.png" className="vr-set-option-arrow" />
              </div>
            </div>
          </div>

          <div className='vr-set-option'>
            <div className="form-check">
              <div className="vr-set-option-img">
                <img src="../img/accountsetting/Vector.png" />
              </div>
              <div className="form-check-label">
                <span className="vr-set-option-title">
                  Connect to Dropbox
                  <p className="vr-set-option-desc">
                    Link Your account to Dropbox for cloud storage integration
                  </p>
                </span>
              </div>
              <div>
                <img src="../img/accountsetting/Frame.png" className="vr-set-option-arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SyncWithCloud
